// extracted by mini-css-extract-plugin
export default {"wrap":"UpdateEntity_wrap__3GTY4","icon":"UpdateEntity_icon__7IAR8","mobile":"UpdateEntity_mobile__XmOVO"};